// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"6041c4e1","48":"7daa5cd0","109":"621f56d3","381":"ba77509b","473":"024ae9a4","543":"47881a83","594":"446d91ee","604":"2465aa05","775":"26865193","806":"a4988c26"}[chunkId] + ".chunk.js";
};